import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { localize } from '@saviynt/common';
import PropTypes from 'prop-types';

import {
  CAMPAIGN_TYPES,
  CAMPAIGNTYPE_ENTITLEMENTOWNER,
} from '../../../utils/constant';
import { certsFormattedMessage, getMessageKey } from '../../../utils/utils';
import {
  BULK_ACTION_FOOTER_BTNS_REVERSE,
  BULK_ACTION_FOOTER_OBJECTS,
  BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS,
  BULK_ACTION_OBJ_PARENT_ENTITLEMENTS,
  BULK_ACTION_OBJ_USERS,
  getBulkActionFooterBtns,
} from '../constant';

function BulkActionReassignSubTitle({ id, bulkFooterStats }) {
  const intl = useIntl();
  const { messages } = useSelector((state) => state?.user);
  const {
    core: { campaignType },
    lineActions: { reassignConfigMap },
  } = useSelector((state) => state?.certifications?.details);
  const isEOCampaign =
    CAMPAIGN_TYPES[campaignType] === CAMPAIGNTYPE_ENTITLEMENTOWNER;

  if (
    id ===
      getBulkActionFooterBtns(campaignType, reassignConfigMap).REASSIGN.id ||
    id ===
      getBulkActionFooterBtns(campaignType, reassignConfigMap)
        .DOES_NOT_BELONG_TO_ME.id
  ) {
    const buttonKey = BULK_ACTION_FOOTER_BTNS_REVERSE?.[id];
    const buttonObjectsForTotal = getBulkActionFooterBtns(
      campaignType,
      reassignConfigMap
    )[buttonKey]?.objectsToTotal;

    const tempSubtitleTextEdit = buttonObjectsForTotal
      ?.filter((key) => bulkFooterStats[key] > 0)
      .map((key) => {
        const messageKey =
          BULK_ACTION_FOOTER_OBJECTS_MESSGAE_KEYS[
            `${BULK_ACTION_FOOTER_OBJECTS[key]}${
              bulkFooterStats[key] > 1 ? 's' : ''
            }`
          ];

        return `${
          messages.messageKey || localize(intl, getMessageKey(messageKey))
        } (${bulkFooterStats[key]})`;
      });

    if (tempSubtitleTextEdit.length === 0) {
      return (
        messages.CERTS_BULK_NOTHING_SELECTED ||
        localize(intl, getMessageKey('CERTS_BULK_NOTHING_SELECTED'))
      );
    }

    if (tempSubtitleTextEdit.length === 1) {
      return certsFormattedMessage(
        (isEOCampaign
          ? messages.CERTS_BULK_REASSIGN_SUB_3_EO
          : messages.CERTS_BULK_REASSIGN_SUB_3) ||
          localize(
            intl,
            getMessageKey(
              isEOCampaign
                ? 'CERTS_BULK_REASSIGN_SUB_3_EO'
                : 'CERTS_BULK_REASSIGN_SUB_3'
            )
          ),
        {
          count: tempSubtitleTextEdit[0],
        }
      );
    }

    const firstText = tempSubtitleTextEdit
      .slice(0, tempSubtitleTextEdit.length - 1)
      .join(', ');

    return certsFormattedMessage(
      (isEOCampaign
        ? messages.CERTS_BULK_REASSIGN_SUB_3_EO
        : messages.CERTS_BULK_REASSIGN_SUB_3) ||
        localize(
          intl,
          getMessageKey(
            isEOCampaign
              ? 'CERTS_BULK_REASSIGN_SUB_3_EO'
              : 'CERTS_BULK_REASSIGN_SUB_3'
          )
        ),
      {
        count: `${firstText} ${
          messages.CERTS_BULK_AND ||
          localize(intl, getMessageKey('CERTS_BULK_AND'))
        } ${tempSubtitleTextEdit[tempSubtitleTextEdit.length - 1]}`,
      }
    );
  }

  const count = isEOCampaign
    ? bulkFooterStats?.[BULK_ACTION_OBJ_PARENT_ENTITLEMENTS]
    : bulkFooterStats?.[BULK_ACTION_OBJ_USERS];

  let messageKey = '';

  if (isEOCampaign) {
    messageKey =
      -count > 1
        ? 'CERTS_BULK_REASSIGN_SUB_1_EO'
        : 'CERTS_BULK_REASSIGN_SUB_2_EO';
  } else {
    messageKey =
      -count > 1 ? 'CERTS_BULK_REASSIGN_SUB_1' : 'CERTS_BULK_REASSIGN_SUB_2';
  }

  return certsFormattedMessage(
    messages[messageKey] || localize(intl, getMessageKey(messageKey)),
    {
      count,
    }
  );
}

BulkActionReassignSubTitle.propTypes = {
  id: PropTypes.string.isRequired,
  bulkFooterStats: PropTypes.shape({}),
};

BulkActionReassignSubTitle.defaultProps = { bulkFooterStats: {} };

export default BulkActionReassignSubTitle;
